<template>
  <div class="income-container">
    <el-form ref="form" :model="form" :inline="true" size="small">
      <el-row>
        <el-col :span="6">
          <el-form-item label="账户名称">
            <el-select filterable clearable v-model="form.region" placeholder="请选择活动区域" style="width: 100%;">
              <el-option v-for="item in accountList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建日期">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商户">
            <el-select v-model="form.region" placeholder="请选择活动区域" style="width: 100%;">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态">
            <el-select v-model="form.region" placeholder="请选择活动区域" style="width: 100%;">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="关键字">
            <el-input v-model="form.name" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" size="small">查询</el-button>
          <el-button type="primary" size="small" plain>重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <div class="status-container">
        <div class="status-item" :class="{ 'active': activeStatus === 'pending' }" @click="setActiveStatus('pending')">
          待审批（100）
        </div>
        <div class="status-item" :class="{ 'active': activeStatus === 'approved' }"
          @click="setActiveStatus('approved')">
          审批通过（22）
        </div>
        <div class="status-item" :class="{ 'active': activeStatus === 'unreceived' }"
          @click="setActiveStatus('unreceived')">
          未收到（5）
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" border max-height="500">
        <el-table-column fixed prop="accountName" label="账户名称">
        </el-table-column>
        <el-table-column prop="typeName" label="类型">
        </el-table-column>
        <el-table-column prop="merchatCompanyName" label="商户">
        </el-table-column>
        <el-table-column prop="amount" label="金额">
        </el-table-column>
        <el-table-column prop="userName" label="操作人">
        </el-table-column>
        <el-table-column prop="createdTime" label="创建日期">
        </el-table-column>
        <el-table-column prop="statusName" label="审批状态">
          <template slot-scope="scope">
            <span v-if="scope.row.approvalStatus === 'passed'" style="color: #67C23A;">通过</span>
            <span v-else-if="scope.row.approvalStatus === 'failed'" style="color: #F56C6C;">失败</span>
            <span v-else-if="scope.row.approvalStatus === 'pending'" style="color: #E6A23C;">待审</span>
            <span v-else-if="scope.row.approvalStatus === 'unreceived'" style="color: #909399;">未收到</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注">
        </el-table-column>
        <el-table-column prop="imageUrl" label="截图">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.screenshot">
              <i class="el-icon-picture"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.approvalStatus === 'pending'">确认收款</el-button>
            <el-button type="text" size="small">查看订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination @current-change="currentChange" :current-page="query.page" :page-size="query.pageSize"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { queryretransactionrecord,getQueryaccount } from '@/api/finance'
export default {
  data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      activeStatus: 'pending',
      tableData: [],
      accountList:[],
      query: {
        name: '',
        page: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },
  methods: {
    setActiveStatus(status) {
      this.activeStatus = status;
    },
    currentChange() { },
    getQueryretransactionrecord() {
      queryretransactionrecord({
        "Name": this.query.name,
        "Status": "",
        "StartDate": "",
        "EndDate": "",
        MerchantId: "",
        "Page.Index": this.query.page,
        "Page.Size": this.query.pageSize,
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
      })
    },
  },
  created() {
    getQueryaccount({
                "Page.Index": 1,
                "Page.Size": 9999,
            }).then(res => {
                this.accountList = res.data.rows.map(t=>{
                  return {
                    label: t.accountName,
                    value: t.id,
                  }
                });
            })
    this.getQueryretransactionrecord();
  }
}
</script>
<style scoped lang="scss">
.income-container {}

::v-deep .el-form--inline .el-form-item {
  display: flex;
  align-items: center;

  .el-form-item__label {
    width: 70px;
  }

  .el-form-item__content {
    width: calc(100% - 70px);
  }

}

.status-container {
  display: flex;
  margin-bottom: 16px;

  .status-item {
    padding: 4px 12px;
    margin-right: 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 12px;
    border: 1px solid #dcdfe6;

    &:hover {
      background-color: #ecf5ff;
      border-color: #c6e2ff;
    }

    &.active {
      background-color: #409EFF;
      color: white;
      border-color: #409EFF;
      box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
    }
  }
}

.table-pagination {
  margin-top: 15px;
  text-align: right;
}
</style>
